import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';
import { SubfooterComponent } from './component/subfooter/subfooter.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, SubfooterComponent],
  imports: [CommonModule, RouterModule],
  exports: [HeaderComponent, FooterComponent, SubfooterComponent],
})
export class SharedModule {}
